import { Map, AdvancedMarker } from '@vis.gl/react-google-maps'

export default function GoogleMapContainer({
	g_placeid,
	g_lat,
	g_long,
	onPositionChange,
	mapId = 'training-map-id',
	readOnly = false,
}) {
	if (g_lat == null || g_long == null) return null

	const handleMarkerDragEnd = (event) => {
		const latLng = event?.latLng
		if (!latLng) return
		onPositionChange?.(latLng.lat(), latLng.lng())
	}

	return (
		<div className="h-[400px] w-full">
			<Map
				key={g_placeid}
				defaultZoom={15}
				defaultCenter={{ lat: g_lat, lng: g_long }}
				mapId={mapId}
			>
				<AdvancedMarker
					position={{ lat: g_lat, lng: g_long }}
					draggable={!readOnly}
					onDragEnd={readOnly ? undefined : handleMarkerDragEnd}
					title="Selected location"
				/>
			</Map>
		</div>
	)
}
